import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    action: {
      padding: 0,
      textDecoration: "underline",
      textTransform: "none",
      fontWeight: "normal",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
      },
    },
  }),
  { name: "LinkStyledButton" },
);
